import {
  Box,
  FormLabel,
  HStack,
  Input,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import MainInput from "../../../../components/Form/input";

import { getPaymentSubjectRequest } from "../../../../modules/admin-modules/videos/Actions";

const StepOne = ({
  data,
  register,
  errors,
  isFormOne,
  watchTimer,
  setValue,
  watchType,
  isAdd,
}) => {
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };
  const videos = useSelector((state) => state.videos.videos);
  const paymentSubjects = useSelector((state) => state.videos.paymentSubjects);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPaymentSubjectRequest());
  }, []);

  const paymentSubjectsOptions = paymentSubjects?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const videosOptions = videos?.map((data) => {
    return { value: data.id, label: data.title };
  });
  return (
    <VStack
      dir="ltr"
      w="100%"
      flexWrap="wrap"
      justifyContent="space-between"
      spacing="50px"
      display={isFormOne ? "flex" : "none"}
    >
      <Box w="100%">
        <MainInput
          label="Exam title"
          defaultValues={data.name}
          error={errors?.name?.message}
          placeholder="Enter exam title"
          register={register}
          name="name"
        />
      </Box>

      <HStack w="100%" alignItems="flex-start">
        <VStack w="50%" alignItems="flex-start">
          <FormLabel>Add a timer for this exam:</FormLabel>
          <Stack
            direction="row"
            role="group"
            aria-labelledby="my-radio-group"
            spacing="20px"
          >
            <label>
              <input
                {...register("timer", { required: "This field is required" })}
                type="radio"
                value="0"
                defaultChecked={data?.timer == 0 ? true : false}
              />
              No
            </label>
            <label>
              <input
                {...register("timer", { required: "This field is required" })}
                type="radio"
                value="1"
                defaultChecked={data?.timer == 1 ? true : false}
              />
              Yes
            </label>
            <Text color="red">{errors?.timer?.message}</Text>
          </Stack>
        </VStack>

        {watchTimer == 1 && (
          <HStack w="75%">
            <FormLabel w="50%">Timer duration:</FormLabel>

            <MainInput
              label=""
              required={false}
              defaultValues={data.time}
              placeholder="Enter exam duration"
              register={register}
              name="time"
            />
          </HStack>
        )}
        <Box w="100%" paddingLeft={10}>
          <FormLabel>Publishing:</FormLabel>

          <Stack
            direction="row"
            role="group"
            aria-labelledby="my-radio-group"
            spacing="20px"
          >
            <label>
              <input
                {...register("published", {
                  required: "This field is required",
                })}
                type="radio"
                value="0"
                defaultChecked={isAdd ? true : data?.published == 0 ? true : false}
              />
              Publish exam
            </label>
            <label>
              <input
                {...register("published", {
                  required: "This field is required",
                })}
                type="radio"
                value="1"
                defaultChecked={data?.published == 1 ? true : false}
              />
              Do not publish
            </label>
            <Text color="red">{errors?.published?.message}</Text>
          </Stack>
        </Box>
        <Box w="100%">
          <FormLabel>Activation:</FormLabel>

          <Stack
            direction="row"
            role="group"
            aria-labelledby="my-radio-group"
            spacing="20px"
          >
            <label>
              <input
                {...register("enable", {
                  required: "This field is required",
                })}
                type="radio"
                value="0"
                defaultChecked={isAdd ? true : data?.enable == 0 ? true : false}
              />
              Enable exam
            </label>
            <label>
              <input
                {...register("enable", {
                  required: "This field is required",
                })}
                type="radio"
                value="1"
                defaultChecked={data?.enable == 1 ? true : false}
              />
              Disable exam
            </label>
            <Text color="red">{errors?.enable?.message}</Text>
          </Stack>
        </Box>
      </HStack>
      <HStack w="100%" alignItems="flex-start">
        <Box w="100%">
          <FormLabel>Auto-publish results:</FormLabel>

          <Stack
            direction="row"
            role="group"
            aria-labelledby="my-radio-group"
            spacing="20px"
          >
            <label>
              <input
                {...register("auto_publish_result", {
                  required: "This field is required",
                })}
                type="radio"
                value="1"
                defaultChecked={data?.auto_publish_result == 1 ? true : false}
              />
              Publish results
            </label>
            <label>
              <input
                {...register("auto_publish_result", {
                  required: "This field is required",
                })}
                type="radio"
                value="0"
                defaultChecked={isAdd ? true : data?.auto_publish_result == 0 ? true : false}
              />
              Do not publish
            </label>
            <Text color="red">{errors?.auto_publish_result?.message}</Text>
          </Stack>
        </Box>
        <Box w="100%">
          <FormLabel>Allow redo?</FormLabel>

          <Stack
            direction="row"
            role="group"
            aria-labelledby="my-radio-group"
            spacing="20px"
          >
            <label>
              <input
                {...register("redo_flag", {
                  required: "This field is required",
                })}
                type="radio"
                value="1"
                defaultChecked={data?.redo_flag == 1 ? true : false}
              />
              Allow redo
            </label>
            <label>
              <input
                {...register("redo_flag", {
                  required: "This field is required",
                })}
                type="radio"
                value="0"
                defaultChecked={isAdd ? true : data?.redo_flag == 0 ? true : false}
              />
              Do not allow
            </label>
            <Text color="red">{errors?.redo_flag?.message}</Text>
          </Stack>
        </Box>
        <Box w="100%">
          <FormLabel>Importance:</FormLabel>

          <Stack
            direction="row"
            role="group"
            aria-labelledby="my-radio-group"
            spacing="20px"
          >
            <label>
              <input
                {...register("book_mark", {
                  required: "This field is required",
                })}
                type="radio"
                value="0"
                defaultChecked={isAdd ? true : data?.book_mark == 0 ? true : false}
              />
              Regular
            </label>
            <label>
              <input
                {...register("book_mark", {
                  required: "This field is required",
                })}
                type="radio"
                value="1"
                defaultChecked={data?.book_mark == 1 ? true : false}
              />
              Bookmarked
            </label>
            <Text color="red">{errors?.book_mark?.message}</Text>
          </Stack>
        </Box>
      </HStack>
      <HStack w="100%" alignItems="flex-start">
        <Box w="100%">
          <FormLabel>Exam type:</FormLabel>

          <Stack
            direction="row"
            role="group"
            aria-labelledby="my-radio-group"
            spacing="20px"
          >
            <label>
              <input
                {...register("type", { required: "This field is required" })}
                type="radio"
                value="1"
                defaultChecked={isAdd ? true : data?.type == 1 ? true : false}
              />
              Exam
            </label>
            <label>
              <input
                {...register("type", { required: "This field is required" })}
                type="radio"
                value="2"
                defaultChecked={data?.type == 2 ? true : false}
              />
              Homework/Classified
            </label>
            <label>
              <input
                {...register("type", { required: "This field is required" })}
                type="radio"
                value="6"
                defaultChecked={data?.type == 6 ? true : false}
              />
              Video exam
            </label>
            <label>
              <input
                {...register("type", { required: "This field is required" })}
                type="radio"
                value="7"
                defaultChecked={data?.type == 7 ? true : false}
              />
              Edutopia Practice{" "}
            </label>
            <label>
              <input
                {...register("type", { required: "This field is required" })}
                type="radio"
                value="5"
                defaultChecked={data?.type == 5 ? true : false}
              />
              Paper exam (center)
            </label>
            <Text color="red">{errors?.type?.message}</Text>
          </Stack>
        </Box>

        {watchType == 6 && (
          <HStack w="100%" gap="30px" alignItems="flex-end">
            <Box w="100%">
              <FormLabel>Select video:</FormLabel>
              <Select
                options={videosOptions}
                isMulti={false}
                onChange={(data) => {
                  setValue("video_id", data?.value);
                }}
                styles={colourStyles}
                placeholder="Video"
                defaultValue={{
                  label: data?.video?.title,
                  value: data?.video?.id,
                }}
              />
            </Box>
          </HStack>
        )}
      </HStack>
      <Box w="100%">
        <FormLabel>Exam difficulty:</FormLabel>

        <Stack
          direction="row"
          role="group"
          aria-labelledby="my-radio-group"
          spacing="20px"
        >
          <label>
            <input
              {...register("difficulty")}
              type="radio"
              value="0"
              defaultChecked={isAdd ? true : data?.difficulty == 0 ? true : false}
            />
            All
          </label>
          <label>
            <input
              {...register("difficulty")}
              type="radio"
              value="1"
              defaultChecked={data?.difficulty == 1 ? true : false}
            />
            Notes
          </label>
          <label>
            <input
              {...register("difficulty")}
              type="radio"
              value="2"
              defaultChecked={data?.difficulty == 2 ? true : false}
            />
            Studying and remembering
          </label>
          <label>
            <input
              {...register("difficulty")}
              type="radio"
              value="3"
              defaultChecked={data?.difficulty == 3 ? true : false}
            />
            Hard and challenging
          </label>
          <label>
            <input
              {...register("difficulty")}
              type="radio"
              value="4"
              defaultChecked={data?.difficulty == 4 ? true : false}
            />
            Previous exams
          </label>
          <label>
            <input
              {...register("difficulty")}
              type="radio"
              value="5"
              defaultChecked={data?.difficulty == 5 ? true : false}
            />
            Revision
          </label>
        </Stack>
      </Box>
      <HStack w="100%">
        <Box w="100%">
          <FormLabel>Payment subject:</FormLabel>
          <Select
            options={paymentSubjectsOptions}
            isMulti={false}
            onChange={(data) => {
              setValue("payment_subject_id", data?.value);
            }}
            styles={colourStyles}
            placeholder="Select payment subject"
            defaultValue={data?.payment_subject?.map((val) => {
              return { label: val?.name, value: val?.id };
            })}
          />
        </Box>
        <Box w="100%">
          <FormLabel>Passing score:</FormLabel>
          <Input
            {...register("success_score", { required: false })}
            type="number"
            placeholder="Enter passing score"
            defaultValue={data?.success_score}
            bg="#f5f5f5"
          />
        </Box>
      </HStack>
    </VStack>
  );
};

export default StepOne;
